<!-- PRINT -->
<div *ngIf="block" class="container-general-print-header no-print px-4">
    <div class="image">
        <img loading="lazy" *ngIf="block.immagine" [src]="domainWebsite + block.immagine" alt="image-hero">
    </div>
    <div>
        <p *ngIf="block.tipo_di_corso" class="ls-p text-brand-10" [innerHTML]="block.tipo_di_corso"></p>
        <p *ngIf="block.titolo" class="ls-h3-item-p-title text-brand-10" [innerHTML]="block.titolo"></p>
        <p *ngIf="block.classe_di_laurea" class="ls-p text-brand-10" [innerHTML]="block.classe_di_laurea"></p>
    </div>
    <!-- Header field -->
    <div *ngIf="!isSecondLevelUp">
        <div *ngIf="luogo || dipartimenti.length">
            <div *ngIf="luogo">
                <p class="text-support-40 ls-label-small-bold text-uppercase margin-b8"
                    [innerHTML]='"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.TAXONOMY.CITY" | translate'></p>
                <div class="d-flex flex-wrap">
                    <p class="mb-1 me-2 text-neutral-30 ls-p-small" [innerHTML]="luogo">
                    </p>
                </div>
            </div>
            <div *ngIf="dipartimenti.length">
                <p class="text-support-40 ls-label-small-bold text-uppercase margin-b8">
                    {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.DEPARTMENT" | translate}}</p>
                <div class="d-flex flex-wrap">
                    <p class="mb-1 me-2 text-neutral-30 ls-p-small" *ngFor="let item of dipartimenti; let idx = index;"
                        [innerHTML]="idx !== (dipartimenti.length - 1) ? item.name + ', ' : item.name">
                    </p>
                </div>
            </div>
        </div>
        <div *ngIf="node.field_lingua.length || node.field_durata.length || block.cfu_etcs">
            <div *ngIf="node.field_lingua.length">
                <p class="text-support-40 ls-label-small-bold text-uppercase">
                    {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.LANGUAGE" | translate}}</p>
                <div class="d-flex flex-column">
                    <div *ngFor="let item of node.field_lingua;">
                        <ng-container [ngSwitch]="item.value">
                            <span *ngSwitchCase="'Italiano'">IT</span>
                            <span *ngSwitchCase="'Inglese'">EN</span>
                            <!-- <img loading="lazy" *ngSwitchCase="'Italiano'" src="../../../../../../assets/images/italy.png" alt="italy">
                                <img loading="lazy" *ngSwitchCase="'Inglese'" src="../../../../../../assets/images/united-kingdom.png" alt="united-kingdom"> -->
                        </ng-container>
                    </div>
                </div>
            </div>
            <div *ngIf="node.field_durata.length">
                <p class="text-support-40 ls-label-small-bold text-uppercase">
                    {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.DURATION" | translate}}</p>
                <div class="d-flex flex-wrap">
                    <p class="text-neutral-30 ls-p-small" *ngFor="let item of node.field_durata; let idx = index;"
                        [innerHTML]="idx !== (node.field_durata.length - 1) ? item.value + ', ' : item.value">
                    </p>
                </div>
            </div>
            <div *ngIf="block.cfu_etcs">
                <p class="text-support-40 ls-label-small-bold text-uppercase">
                    {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.CREDITS" | translate}}</p>
                <div class="d-flex flex-wrap">
                    <p class="text-neutral-30 ls-p-small" [innerHTML]="block.cfu_etcs | number">
                    </p>
                </div>
            </div>
        </div>
        <div
            *ngIf="block.valutazione_didattica.dato || block.valutazione_didattica.descrizione_dato || block.valutazione_didattica.link">
            <div *ngIf="block.valutazione_didattica.dato">
                <p class="text-support-40 ls-label-small-bold text-uppercase"
                    [innerHTML]="block.valutazione_didattica.titolo_blocco"></p>
                <h4 class="text-garamond">{{ block.valutazione_didattica.dato }}</h4>
            </div>
            <div *ngIf="block.valutazione_didattica.descrizione_dato">
                <p class="text-neutral-30 ls-p-small" [innerHTML]="block.valutazione_didattica.descrizione_dato">
                </p>
            </div>
            <div *ngIf="block.valutazione_didattica.link">
                <a *ngIf="isExternalLink" [href]="block.valutazione_didattica.link" target="_blank ">
                    <p class="text-brand-40 ls-label-small-semibold text-uppercase">
                        <span
                            *ngIf="!block.valutazione_didattica.label_link">{{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.EVALUATION_OF_TEACHING"
                            | translate}}</span>
                        <span *ngIf="block.valutazione_didattica.label_link"
                            [innerHTML]="block.valutazione_didattica.label_link"></span>
                    </p>
                </a>
                <a *ngIf="!isExternalLink"
                    [routerLink]="navigationService.splitUrlRouterLink(block.valutazione_didattica.link).path"
                    [queryParams]="navigationService.splitUrlRouterLink(block.valutazione_didattica.link).queryParams">
                    <p class="text-brand-40 ls-label-small-semibold text-uppercase">
                        <span
                            *ngIf="!block.valutazione_didattica.label_link">{{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.EVALUATION_OF_TEACHING"
                            | translate}}</span>
                        <span *ngIf="block.valutazione_didattica.label_link"
                            [innerHTML]="block.valutazione_didattica.label_link"></span>
                    </p>
                </a>
            </div>
        </div>
        <div *ngIf="areeTematiche.length || keywords.length" class="container-items__item padding-x d-flex flex-column">
            <div *ngIf="areeTematiche.length">
                <p class="text-support-40 ls-label-small-bold text-uppercase">
                    {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.THEMATIC_AREAS" | translate}}</p>
                <div class="d-flex flex-wrap">
                    <p class="text-neutral-30 ls-p-small" *ngFor="let item of areeTematiche; let idx = index;"
                        [innerHTML]="idx !== (areeTematiche.length - 1) ? item.name + ', ' : item.name">
                    </p>
                </div>
            </div>
            <div *ngIf="keywords.length">
                <p class="text-support-40 ls-label-small-bold text-uppercase">
                    {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.KEYWORD" | translate}}</p>
                <div class="d-flex flex-wrap">
                    <p class="text-neutral-30 ls-p-small" *ngFor="let item of keywords; let idx = index;"
                        [innerHTML]="idx !== (keywords.length - 1) ? item.name + ', ' : item.name">
                    </p>
                </div>
            </div>
        </div>
        <div *ngIf="block.presidente_coordinatore">
            <div class="d-flex flex-column justify-content-between h-100">
                <div>
                    <p *ngIf="block.presidente_coordinatore.titolo_blocco"
                        class="text-support-40 ls-label-small-bold text-uppercase"
                        [innerHTML]="block.presidente_coordinatore.titolo_blocco"></p>
                    <div *ngIf="block.presidente_coordinatore.foto" class="profile">
                        <img loading="lazy" class="position-absolute"
                            [src]="domainWebsite + block.presidente_coordinatore.foto" alt="image">
                    </div>
                    <p class="ls-p-semibold text-brand-10" [innerHTML]="block.presidente_coordinatore.nome_cognome">
                    </p>
                    <p class="ls-p-small text-neutral-30" [innerHTML]="block.presidente_coordinatore.ruolo"></p>
                </div>
                <div>
                    <a *ngIf="!isLinkEsternal && block.presidente_coordinatore.link && block.presidente_coordinatore.link !== '#'"
                        [routerLink]="navigationService.splitUrlRouterLink(block.presidente_coordinatore.link).path"
                        [queryParams]="navigationService.splitUrlRouterLink(block.presidente_coordinatore.link).queryParams">
                        <p class="text-brand-40 ls-label-small-semibold text-uppercase cursor-pointer">
                            {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.PROFILE" | translate}}</p>
                    </a>
                    <a *ngIf="isLinkEsternal && block.presidente_coordinatore.link && block.presidente_coordinatore.link !== '#'"
                        [href]="block.presidente_coordinatore.link" target="_blank">
                        <p class="text-brand-40 ls-label-small-semibold text-uppercase">
                            {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.PROFILE" | translate}}
                        </p>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <!-- END Header field -->
</div>
<!-- END PRINT -->
<ng-container *ngIf="node && block && !isSecondLevelUp">
    <header
        class="container-page-general position-relative d-flex flex-column align-items-center justify-content-between no-print"
        [ngClass]="{'bg-overlay': !isSecondLevelUp}">
        <app-breadcrumb-first *ngIf="!isSecondLevelUp" [title]="node.title[0].value" [isSecondLevelUp]="false"
            [type_page]="node.type[0].target_id" class="container-page-general__breadcrumb mt-2"></app-breadcrumb-first>
        <img loading="lazy" *ngIf="block.immagine" class="position-absolute" [src]="domainWebsite + block.immagine"
            alt="image-hero">
        <div *ngIf="!isSecondLevelUp" class="container-page-general__title w-100 text-center">
            <div>
                <p *ngIf="block.tipo_di_corso" class="ls-p text-neutral-80" [innerHTML]="block.tipo_di_corso"></p>
                <h1 *ngIf="block.titolo" class="ls-h1-page-title text-neutral-A1" [innerHTML]="block.titolo"></h1>
                <p *ngIf="block.classe_di_laurea" class="ls-p text-neutral-80" [innerHTML]="block.classe_di_laurea"></p>
                <div class="d-flex align-items-center justify-content-center mt-5">
                    <div *ngIf="node.field_cta_form && node.field_cta_form.length">
                        <a *ngIf="node.field_cta_form[0].uri" [href]="node.field_cta_form[0].uri"
                            class="form-button mb-1 me-2 margin-b8">
                            <img loading="lazy" src="../../../../../../assets/images/info.svg" alt="icon-info"
                               class="me-2" style="width: 20px; height: 20px;">
                            <span *ngIf="node.field_cta_form[0].title" class="ls-label-medium-semibold text-uppercase">{{node.field_cta_form[0].title}}</span>
                        </a>
                    </div>
                    <div *ngIf="block.link_video_corso" class="cursor-pointer">
                        <div class="container-page-general__container-share first cursor-pointer" (click)="openModalVideo()">
                            <img loading="lazy" src="../../../../../../assets/images/play-circle.svg" alt="icon-play"
                                class="me-lg-2" style="width: 20px; height: 20px;">
                            <p class="m-0 ls-label-medium-semibold text-uppercase d-none d-lg-block">{{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.WATCH_VIDEO" | translate}}</p>
                            <!-- <a (click)="openModalVideo()">
                            <img loading="lazy" src="../../../../../../assets/images/play.png" alt="icon-play"
                                style="width: 50px; height: 50px;">
                        </a> -->
                        </div>
                    </div>
                    <div class="container-page-general__container-share second cursor-pointer"
                            (mouseenter)="onHoverShare = true" (mouseleave)="onHoverShare = false"
                            (click)="nodeService.openModaleShare()">
                            <p class="m-0 ls-label-medium-semibold text-uppercase d-none d-lg-block">{{"MODAL_SHARE.SEND_TO" | translate}}
                            </p>
                            <img loading="lazy" *ngIf="!onHoverShare" class="ms-lg-2"
                                src="../../../../../../assets/images/share-icon/share-icon-white.png" alt="share icon">
                            <img loading="lazy" *ngIf="onHoverShare" class="ms-lg-2"
                                src="../../../../../../assets/images/share-icon/share-icon-yellow.png" alt="share icon">
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="!isSecondLevelUp"
            class="container-page-general__container-anchor text-white position-absolute w-100"
            style="bottom: 10px; padding: 0 10px;">
            <app-sample-anchor *ngIf="anchorItems" [anchorItems]="anchorItems" [idAnchor]="idAnchor"
                [color]="!block.field_immagine ? '#02180F' : '#ffffff'" [positionType]="'position-sticky'"
                [positionTop]="'120px'" [bgColor]="'transparent'" [setOffset]="250" [styleHeader]="'first'">
            </app-sample-anchor>
        </div>
    </header>
</ng-container>
<ng-container *ngIf="node && block && isSpinner; else spinner">
    <!-- Header field -->
    <section *ngIf="!isSecondLevelUp" id="container-field-taxonomies"
        class="container-items d-flex flex-wrap flex-lg-nowrap w-100 justify-content-between align-items-stretch border-top border-bottom no-print">
        <div *ngIf="luogo || dipartimenti.length" class="container-items__item padding-x d-flex flex-column">
            <div *ngIf="luogo" class="padding-y">
                <p class="text-support-40 ls-label-small-bold text-uppercase margin-b8"
                    [innerHTML]='"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.TAXONOMY.CITY" | translate'></p>
                <div class="d-flex flex-wrap">
                    <p class="mb-1 me-2 text-neutral-30 ls-p-small" [innerHTML]="luogo">
                    </p>
                </div>
            </div>
            <div *ngIf="dipartimenti.length" class="padding-y">
                <p class="text-support-40 ls-label-small-bold text-uppercase margin-b8">
                    {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.DEPARTMENT" | translate}}</p>
                <div class="d-flex flex-wrap">
                    <p class="mb-1 me-2 text-neutral-30 ls-p-small" *ngFor="let item of dipartimenti; let idx = index;"
                        [innerHTML]="idx !== (dipartimenti.length - 1) ? item.name + ', ' : item.name">
                    </p>
                </div>
            </div>
        </div>
        <div *ngIf="node.field_lingua.length || node.field_durata.length || block.cfu_etcs"
            class="container-items__item padding-x border-sides-field">
            <div *ngIf="node.field_lingua.length" class="padding-y">
                <p class="text-support-40 ls-label-small-bold text-uppercase">
                    {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.LANGUAGE" | translate}}</p>
                <div class="d-flex flex-column">
                    <div *ngFor="let item of node.field_lingua;">
                        <ng-container [ngSwitch]="item.value">
                            <span *ngSwitchCase="'Italiano'">IT</span>
                            <span *ngSwitchCase="'Inglese'">EN</span>
                        </ng-container>
                    </div>
                </div>
            </div>
            <div *ngIf="block.durata" class="padding-y">
                <p class="text-support-40 ls-label-small-bold text-uppercase">
                    {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.DURATION" | translate}}</p>
                <div class="d-flex flex-wrap">
                    <p class="mb-1 me-2 text-neutral-30 ls-p-small" [innerHTML]="block.durata">
                    </p>
                </div>
            </div>
            <div *ngIf="block.cfu_etcs" class="padding-y">
                <p class="text-support-40 ls-label-small-bold text-uppercase">
                    {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.CREDITS" | translate}}</p>
                <div class="d-flex flex-wrap">
                    <p class="mb-1 me-2 text-neutral-30 ls-p-small" [innerHTML]="block.cfu_etcs | number">
                    </p>
                </div>
            </div>
        </div>
        <div *ngIf="block.valutazione_didattica.dato || block.valutazione_didattica.descrizione_dato || block.valutazione_didattica.link"
            class="container-items__item padding-x d-flex flex-column">
            <div *ngIf="block.valutazione_didattica.dato" class="padding-y container-items__item__valutazione">
                <p class="text-support-40 ls-label-small-bold text-uppercase"
                    [innerHTML]="block.valutazione_didattica.titolo_blocco"></p>
                <h4 class="mb-0 text-garamond">{{ block.valutazione_didattica.dato }}</h4>
            </div>
            <div *ngIf="block.valutazione_didattica.descrizione_dato" class="padding-y">
                <p class="mb-1 me-2 text-neutral-30 ls-p-small"
                    [innerHTML]="block.valutazione_didattica.descrizione_dato"></p>
            </div>
            <div *ngIf="block.valutazione_didattica.link" class="padding-y">
                <a *ngIf="isExternalLink" [href]="block.valutazione_didattica.link" target="_blank ">
                    <p class="mb-1 me-2 text-brand-40 ls-label-small-semibold text-uppercase margin-b8">
                        <span
                            *ngIf="!block.valutazione_didattica.label_link">{{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.EVALUATION_OF_TEACHING"
                            | translate}}</span>
                        <span *ngIf="block.valutazione_didattica.label_link"
                            [innerHTML]="block.valutazione_didattica.label_link"></span>
                    </p>
                </a>
                <a *ngIf="!isExternalLink"
                    [routerLink]="navigationService.splitUrlRouterLink(block.valutazione_didattica.link).path"
                    [queryParams]="navigationService.splitUrlRouterLink(block.valutazione_didattica.link).queryParams">
                    <p class="mb-1 me-2 text-brand-40 ls-label-small-semibold text-uppercase margin-b8">
                        <span
                            *ngIf="!block.valutazione_didattica.label_link">{{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.EVALUATION_OF_TEACHING"
                            | translate}}</span>
                        <span *ngIf="block.valutazione_didattica.label_link"
                            [innerHTML]="block.valutazione_didattica.label_link"></span>
                    </p>
                </a>
            </div>
        </div>
        <div *ngIf="areeTematiche.length || keywords.length"
            class="width-20 container-items__item padding-x d-flex flex-column border-sides-field">
            <div *ngIf="areeTematiche.length" class="padding-y">
                <p class="text-support-40 ls-label-small-bold text-uppercase margin-b8">
                    {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.THEMATIC_AREAS" | translate}}</p>
                <div class="d-flex flex-wrap">
                    <p class="mb-1 me-2 text-neutral-30 ls-p-small" *ngFor="let item of areeTematiche; let idx = index;"
                        [innerHTML]="idx !== (areeTematiche.length - 1) ? item.name + ', ' : item.name">
                    </p>
                </div>
            </div>
            <div *ngIf="keywords.length" class="padding-y">
                <p class="text-support-40 ls-label-small-bold text-uppercase margin-b8">
                    {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.KEYWORD" | translate}}</p>
                <div class="d-flex flex-wrap">
                    <p class="mb-1 me-2 text-neutral-30 ls-p-small" *ngFor="let item of keywords; let idx = index;"
                        [innerHTML]="idx !== (keywords.length - 1) ? item.name + ', ' : item.name">
                    </p>
                </div>
            </div>
        </div>
        <div *ngIf="block.presidente_coordinatore" class="container-items__item padding-x">
            <div class="padding-y d-flex flex-column justify-content-between h-100">
                <div>
                    <p *ngIf="block.presidente_coordinatore.titolo_blocco"
                        class="text-support-40 ls-label-small-bold text-uppercase"
                        [innerHTML]="block.presidente_coordinatore.titolo_blocco"></p>
                    <div *ngIf="block.presidente_coordinatore.foto" class="container-items__item__president"
                        style="margin-bottom: 16px;">
                        <img loading="lazy" class="position-absolute"
                            [src]="domainWebsite + block.presidente_coordinatore.foto" alt="image">
                    </div>
                    <p class="margin-b8 ls-p-semibold text-brand-10"
                        [innerHTML]="block.presidente_coordinatore.nome_cognome">
                    </p>
                    <p class="ls-p-small text-neutral-30" [innerHTML]="block.presidente_coordinatore.ruolo"></p>
                </div>
                <div>
                    <a *ngIf="!isLinkEsternal && block.presidente_coordinatore.link && block.presidente_coordinatore.link !== '#'"
                        [routerLink]="navigationService.splitUrlRouterLink(block.presidente_coordinatore.link).path"
                        [queryParams]="navigationService.splitUrlRouterLink(block.presidente_coordinatore.link).queryParams">
                        <p class="text-brand-40 ls-label-small-semibold text-uppercase cursor-pointer margin-b8">
                            {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.PROFILE" | translate}}</p>
                    </a>
                    <a *ngIf="isLinkEsternal && block.presidente_coordinatore.link && block.presidente_coordinatore.link !== '#'"
                        [href]="block.presidente_coordinatore.link" target="_blank">
                        <p class="text-brand-40 ls-label-small-semibold text-uppercase margin-b8">
                            {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.PROFILE" | translate}}
                        </p>
                    </a>
                </div>
            </div>
        </div>
    </section>
    <!-- END Header field -->
    <!-- HEADER COLLAPSE -->
    <div *ngIf="block && node && !isSecondLevelUp" id="collapse" [ngClass]="{
                'opacity-100 visible bg-neutral-A1': isCollapseHeader,
                'opacity-0 invisible bg-neutral-99': !isCollapseHeader
            }" class="container-page-general-collapse position-fixed no-print">
        <div
            class="container-page-general-collapse__item text-md-center d-flex justify-content-between align-items-center border-bottom-custom">
            <div *ngIf="isShowLocalMenu" class="d-flex align-items-end container-icon-expand m-auto col-1">
                <img loading="lazy" *ngIf="isSecondLevelUp" class="cursor-pointer hidden-phone"
                    src="../../../../../../assets/images/side-menu-expand.svg" alt="menu expand"
                    style="margin-left: 34px;" (click)="openMenu()">
            </div>
            <p *ngIf="block.titolo" class="ls-h1-page-title-collapse col-10 mb-1"
                [ngClass]="{'offset-1': !isShowLocalMenu}" [innerHTML]="block.titolo">
            </p>
            <div class="d-flex justify-content-end align-items-center col-1" [ngClass]="{
                'col-1': block.titolo && isShowLocalMenu,
                'col-11': !block.titolo && isShowLocalMenu,
                'col-12': !block.titolo && !isShowLocalMenu
            }">
                <div class="cursor-pointer" (click)="nodeService.openModaleShare()">
                    <img loading="lazy" src="../../../../../../assets/images/share-icon/share-icon-yellow.png"
                        alt="share icon" style="margin-right: 34px;">
                </div>
            </div>
        </div>
        <div *ngIf="!isSecondLevelUp && anchorItems.length && isCollapseHeader" class="border-bottom-custom"
            style="padding: 16px 10px;">
            <app-sample-anchor *ngIf="anchorItems" [anchorItems]="anchorItems" [positionTop]="'140px'" [setOffset]="250"
                [styleHeader]="'collapse'">
            </app-sample-anchor>
        </div>
    </div>
    <!-- END HEADER COLLAPSE -->
    <!-- obiettivi -->
    <section *ngIf="block.obiettivi_del_corso && !isSecondLevelUp" class="bg-neutral-99">
        <div class="container container-obiettivi">
            <h2 class="ls-h2-section-title text-brand-10 text-center">
                {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.COURSE_TARGETS" | translate}}</h2>
            <div #content class="position-relative" [style.height]="showMore ? 'auto' : visibleHeight + 'px'"
                [style.overflow-y]="showMore ? 'visible' : 'hidden'"
                [ngClass]="!(content.scrollHeight > visibleHeight) ? 'mb-5' : 'mb-0'">
                <article class="ls-p text-neutral-30" [innerHTML]="helpersService.modifyLinks(block.obiettivi_del_corso, domainWebsite) | safeHtml"></article>
                <div *ngIf="!showMore && content.scrollHeight > visibleHeight" class="fade-overlay"></div>
            </div>
            <div *ngIf="content.scrollHeight > visibleHeight" class="w-100 d-flex justify-content-center"
                style="padding: 40px 0 80px 0;">
                <button class="btn btn-secondario text-uppercase ls-label-small" (click)="showMore = !showMore">
                    {{ showMore ? ("CONTENT_TYPES.PAGE_DOCENTI.READ_LESS" | translate) :
                    ("CONTENT_TYPES.PAGE_DOCENTI.KEEP_READING" | translate) }}
                </button>
            </div>
        </div>
    </section>
    <!-- END obiettivi -->
    <!-- CTA -->
    <section *ngIf="!isSecondLevelUp" class="container-cta d-flex flex-wrap bg-neutral-99" id="container-cta">
        <div *ngIf="block.con_collegamento_offerta"
            class="container-cta__item d-flex flex-column justify-content-between {{ columnCTA }}">
            <div>
                <div class="container-cta__item__icon mb-3">
                    <img loading="lazy" src="../../../../../assets/images/contenuto_corso_icon.svg"
                        alt="contenuto_corso_icon">
                </div>
                <div class="container-cta__item__text">
                    <p
                        class="container-cta__item__text__title ls-label-medium-semibold text-neutral-30 text-uppercase mb-1">
                        {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.EDUCATIONAL_OFFER_ENROLLED_STUDENTS.TITLE" | translate}}
                    </p>
                    <p class="ls-p-small text-neutral-30">
                        {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.EDUCATIONAL_OFFER_ENROLLED_STUDENTS.SUBTITLE" | translate}}
                    </p>
                </div>
            </div>
            <div class="container-cta__item__container-button">
                <button
                    class="container-cta__item__container-button__button btn btn-secondario ls-label-small-semibold text-brand-40 text-uppercase m-0 cursor-pointer"
                    (click)="openModalCorsi()">
                    {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.DISCOVER_COURSES_ACADEMIC_YEAR_IN_PROGRESS" | translate}}
                </button>
            </div>
        </div>
        <div *ngIf="block.collegamento_offerta_prossimo_anno"
            class="container-cta__item d-flex flex-column justify-content-between {{ columnCTA }}">
            <div>
                <div class="container-cta__item__icon mb-3">
                    <img loading="lazy" src="../../../../../assets/images/dad_icon.svg" alt="dad_icon">
                </div>
                <div class="container-cta__item__text">
                    <p
                        class="container-cta__item__text__title ls-label-medium-semibold text-neutral-30 text-uppercase mb-1">
                        {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.EDUCATIONAL_OFFER_FUTURE_STUDENTS.TITLE" | translate}}
                    </p>
                    <p class="ls-p-small text-neutral-30">
                        {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.EDUCATIONAL_OFFER_FUTURE_STUDENTS.SUBTITLE" | translate}}
                    </p>
                </div>
            </div>
            <div class="container-cta__item__container-button">
                <button
                    class="container-cta__item__container-button__button btn btn-secondario ls-label-small-semibold text-brand-40 text-uppercase m-0 cursor-pointer"
                    (click)="goToTarget()">
                    {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.DISCOVER_WHAT_YOU_WILL_STUDY" | translate}}
                </button>
            </div>
        </div>
        <div *ngIf="block.con_collegamento_docenti"
            class="container-cta__item d-flex flex-column justify-content-between {{ columnCTA }}">
            <div>
                <div class="container-cta__item__icon mb-3">
                    <img loading="lazy" src="../../../../../assets/images/e-learning_icon.svg" alt="e-learning_icon">
                </div>
                <div class="container-cta__item__text">
                    <p
                        class="container-cta__item__text__title ls-label-medium-semibold text-neutral-30 text-uppercase mb-1">
                        {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.ALL_TEACHERS_OF_DEGREE_COURSE.TITLE" | translate}}
                    </p>
                    <p class="ls-p-small text-neutral-30">
                        {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.ALL_TEACHERS_OF_DEGREE_COURSE.SUBTITLE" | translate}}
                    </p>
                </div>
            </div>
            <div class="container-cta__item__container-button">
                <button
                    class="container-cta__item__container-button__button btn btn-secondario ls-label-small-semibold text-brand-40 text-uppercase m-0 cursor-pointer"
                    (click)="getAllDocentiCorso()">
                    {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.FIND_OUT" | translate}}
                </button>
            </div>
        </div>
    </section>
    <!-- END CTA -->
    <ng-container *ngIf="node.field_layout_righe && node.field_layout_righe.length">
        <div class="container-row">
            <div *ngFor="let row of node.field_layout_righe; let idx = index">
                <app-row [lang]="node.langcode[0].value" [rowId]="row.target_id" [position]="idx"
                    [attr.rowid]="row.target_id" [preview]="node.preview"
                    [offerta_formativa_id]="block.collegamento_offerta_prossimo_anno"
                    (objAnchor)="addNewAnchorItem($event)">
                </app-row>
            </div>
        </div>
    </ng-container>
</ng-container>
<!-- SPINNER -->
<ng-template #spinner>
    <app-spinner></app-spinner>
</ng-template>
<!-- MODALE CORSI-->
<ng-template #modalCorsi let-modal>
    <ng-container *ngIf="block">
        <div class="container-header bg-brand-99">
            <div class="container-header__top-bar d-flex justify-content-between align-items-center text-uppercase">
                <div class="col-1 text-center">
                    <div class="cursor-pointer" *ngIf="isStep2" (click)="resetBoolean()">
                        <i class="fa-solid fa-arrow-left text-brand-40" aria-hidden="true"></i>
                    </div>
                </div>
                <p *ngIf="block.titolo" class="col-10 ls-label-medium-semibold text-brand-40 text-center m-0"
                    id="modal-basic-title" [innerHTML]="isStep2 ? titleModal : block.titolo"></p>
                <div class="col-1 close cursor-pointer text-center" aria-label="Close"
                    (click)="modal.dismiss(resetBoolean())">
                    <i class="fa-solid fa-plus text-brand-40" style="transform: rotate(45deg);" aria-hidden="true"></i>
                </div>
            </div>
        </div>
        <div *ngIf="offerta_formativa && block && !isStep2" class="p-5">
            <h3 *ngIf="block.offerta_formativa_esse3 && offerta_formativa && offerta_formativa.length && offerta_formativa[0].teachings && offerta_formativa[0].teachings[0].aaOffId"
                class="ls-h3-section-title text-brand-10 text-center">
                {{ 'CONTENT_TYPES.PAGE_CORSO_DI_STUDI.HEADER_STEP_1.TITLE' | translate }}
                {{ offerta_formativa[0].teachings[0].aaOffId + '-' + (offerta_formativa[0].teachings[0].aaOffId+1) }}
            </h3>
            <div *ngIf="block.offerta_formativa_esse3" class="px-2 py-4 bg-neutral-99">
                <div class="d-flex">
                    <div class="col-1 d-flex justify-content-center align-items-center">
                        <img loading="lazy" src="../../../../../../assets/images/icon_info_modal.svg"
                            alt="LUMSA_icon_info">
                    </div>
                    <div class="col-11">
                        <p class="mb-0 ls-p-semibold text-brand-10">{{
                            'CONTENT_TYPES.PAGE_CORSO_DI_STUDI.HEADER_STEP_1.TEXT_1' | translate }}</p>
                        <p class="mb-0 ls-p-small">{{ 'CONTENT_TYPES.PAGE_CORSO_DI_STUDI.HEADER_STEP_1.TEXT_2' |
                            translate }}
                            <a class="text-brand-40" href="https://servizi.lumsa.it/" target="_blank">{{
                                'CONTENT_TYPES.PAGE_CORSO_DI_STUDI.HEADER_STEP_1.CTA' | translate }}</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="offerta_formativa && dataSteps2 && dataSteps2.length && block && isStep2" class="p-5">
            <div class="px-2 py-4 bg-neutral-99">
                <div class="d-flex">
                    <div class="col-1 d-flex justify-content-center pt-2">
                        <img loading="lazy" src="../../../../../../assets/images/icon_info_modal.svg"
                            alt="LUMSA_icon_info" style="width: 24px; height: 24px;">
                    </div>
                    <div class="col-11">
                        <p class="mb-0 ls-p-semibold text-brand-10">{{
                            'CONTENT_TYPES.PAGE_CORSO_DI_STUDI.HEADER_STEP_2.TEXT_1' | translate }}</p>
                        <!-- <p class="mb-0 ls-p-small">{{ 'CONTENT_TYPES.PAGE_CORSO_DI_STUDI.HEADER_STEP_2.TEXT_2' | translate }}
                            <a class="text-brand-40" href="#">{{ 'CONTENT_TYPES.PAGE_CORSO_DI_STUDI.HEADER_STEP_2.CTA_2' | translate }}</a>
                        </p>     -->
                        <p class="mb-0 ls-p-small">{{ 'CONTENT_TYPES.PAGE_CORSO_DI_STUDI.HEADER_STEP_2.TEXT_3' |
                            translate }}
                            <a class="text-brand-40" href="https://servizi.lumsa.it/" target="_blank">{{
                                'CONTENT_TYPES.PAGE_CORSO_DI_STUDI.HEADER_STEP_2.CTA_3' | translate }}</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-body">
            <!-- STEP 1 -->
            <ng-container *ngIf="offerta_formativa && offerta_formativa.length && !isStep2">
                <div class="container-body__step1">
                    <ng-container *ngFor="let offerta of offerta_formativa">
                        <p class="container-body__step1__anno ls-label-medium-semibold text-neutral-50 text-uppercase"
                            [innerHTML]="offerta.anno_di_riferimento"></p>
                        <ng-container *ngFor="let result of offerta.result">
                            <div class="container-body__step1__header">
                                <p class="container-body__step1__header__percorso ls-label-medium-semibold text-brand-10 text-uppercase"
                                    [innerHTML]="removeComunePrefix(result.nome_percorso)"></p>
                            </div>
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th scope="col" class="ls-label-small-semibold text-uppercase">
                                            {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.TEACHING" | translate}}</th>
                                        <th scope="col" class="ls-label-small-semibold text-uppercase">
                                            {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.ACADEMIC_YEAR" | translate}}</th>
                                        <!-- <th scope="col" class="ls-label-small-semibold text-uppercase">
                                                        {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.SSD" | translate}}</th> -->
                                        <th scope="col" class="ls-label-small-semibold text-uppercase">
                                            {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.CFU" | translate}}</th>
                                        <th scope="col" class="ls-label-small-semibold text-uppercase">
                                            {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.OBLIGATORY" | translate}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let teaching of result.teachings;">
                                        <th class="col-6" scope="row">
                                            <p class="m-0 text-brand-40 ls-p cursor-pointer" [innerHTML]="teaching.name"
                                                (click)="getAttivitaDitatticaDettaglio(teaching.aaOffId, teaching.adId, teaching.specificPdsCod, teaching.adCod, result.nome_percorso, teaching.name, teaching.cdsCod)">
                                            </p>
                                        </th>
                                        <td class="col-2">
                                            <p class="m-0 ls-p text-neutral-30"
                                                [innerHTML]="teaching.aaOffId + '-' + (teaching.aaOffId + 1)"></p>
                                        </td>
                                        <!-- <td class="col-2">
                                                        <p class="m-0 ls-p text-neutral-30" [innerHTML]="teaching.ssd"></p>
                                                    </td> -->
                                        <td class="col-1">
                                            <p class="m-0 ls-p text-neutral-30" [innerHTML]="teaching.weight | number">
                                            </p>
                                        </td>
                                        <td class="col-1">
                                            <p class="m-0 ls-p text-neutral-30 text-capitalize">
                                                {{ teaching.obbligatorio ?
                                                ('CONTENT_TYPES.PAGE_CORSO_DI_STUDI.YES' | translate) :
                                                ('CONTENT_TYPES.PAGE_CORSO_DI_STUDI.NO' | translate)
                                                }}
                                            </p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </ng-container>
                    </ng-container>
                </div>
            </ng-container>
            <!-- END STEP 1 -->
            <!-- STEP 2 -->
            <ng-container *ngIf="isStep2">
                <div class="container-nav">
                    <ul ngbNav [(activeId)]="active" class="container-nav__tabs nav-tabs" #nav="ngbNav"
                        [animation]="true" [class.one-datastep2]="dataSteps2 && dataSteps2.length === 1"
                        [destroyOnHide]="true">
                        <li *ngFor="let dataStep2 of dataSteps2; let idx = index;" [ngbNavItem]="idx"
                            class="container-nav__tabs__items">
                            <a ngbNavLink class="container-nav__tabs__items__text-tab ls-label-small-semibold">
                                {{dataStep2.des_partizione}}
                            </a>
                            <ng-template ngbNavContent>
                                <div *ngIf="dataStep2 && isSpinnerStep2" id="body_step2"
                                    class="d-flex flex-wrap container-body__step2">
                                    <div class="container-body__step2__column-left p-4 col-12 col-lg-4">
                                        <div class="d-flex container-body__step2__column-left__item" style="gap: 24px;">
                                            <div class="container-body__step2__column-left__item__title col-6">
                                                <p class="ls-label-small-semibold text-brand-10 text-uppercase">
                                                    {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.DEGREE_COURSE" | translate}}
                                                </p>
                                            </div>
                                            <div class="container-body__step2__column-left__item__text col-6">
                                                <p class="ls-p-small text-neutral-30" [innerHTML]="block.titolo"></p>
                                            </div>
                                        </div>
                                        <div *ngIf="dataStep2.percorso"
                                            class="d-flex container-body__step2__column-left__item" style="gap: 24px;">
                                            <div class="container-body__step2__column-left__item__title col-6">
                                                <p class="ls-label-small-semibold text-brand-10 text-uppercase">
                                                    {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.PATH" | translate}}</p>
                                            </div>
                                            <div class="container-body__step2__column-left__item__text col-6">
                                                <p class="ls-p-small text-neutral-30" [innerHTML]="dataStep2.percorso">
                                                </p>
                                            </div>
                                        </div>
                                        <div *ngIf="dataStep2.aa"
                                            class="d-flex container-body__step2__column-left__item" style="gap: 24px;">
                                            <div class="container-body__step2__column-left__item__title col-6">
                                                <p class="ls-label-small-semibold text-brand-10 text-uppercase">
                                                    {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.A.A" | translate}}</p>
                                            </div>
                                            <div class="container-body__step2__column-left__item__text col-6">
                                                <p class="ls-p-small text-neutral-30"
                                                    [innerHTML]="dataStep2.aa + ' / ' + (dataStep2.aa + 1)">
                                                </p>
                                            </div>
                                        </div>
                                        <div *ngIf="dataStep2.docenti && dataStep2.docenti.length"
                                            class="d-flex container-body__step2__column-left__item" style="gap: 24px;">
                                            <div class="container-body__step2__column-left__item__title col-6">
                                                <p class="ls-label-small-semibold text-brand-10 text-uppercase">
                                                    {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.TEACHERS" | translate}}</p>
                                            </div>
                                            <div class="container-body__step2__column-left__item__text col-6">
                                                <p class="ls-p-small text-neutral-30"
                                                    *ngFor="let docente of dataStep2.docenti; let idx = index;"
                                                    [innerHTML]="idx !== (dataStep2.docenti.length - 1) ? docente + ', ' : docente">
                                                </p>
                                            </div>
                                        </div>
                                        <div *ngIf="dataStep2.lingua_insegnamento !== ''"
                                            class="d-flex container-body__step2__column-left__item" style="gap: 24px;">
                                            <div class="container-body__step2__column-left__item__title col-6">
                                                <p class="ls-label-small-semibold text-brand-10 text-uppercase">
                                                    {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.LANGUAGE" | translate}}</p>
                                            </div>
                                            <div class="container-body__step2__column-left__item__text col-6">
                                                <p class="ls-p-small text-neutral-30"
                                                    [innerHTML]="dataStep2.lingua_insegnamento">
                                                </p>
                                            </div>
                                        </div>
                                        <div *ngIf="dataStep2.ssd !== ''"
                                            class="d-flex container-body__step2__column-left__item" style="gap: 24px;">
                                            <div class="container-body__step2__column-left__item__title col-6">
                                                <p class="ls-label-small-semibold text-brand-10 text-uppercase">
                                                    {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.SSD" | translate}}</p>
                                            </div>
                                            <div class="container-body__step2__column-left__item__text col-6">
                                                <p class="ls-p-small text-neutral-30" [innerHTML]="dataStep2.ssd"></p>
                                            </div>
                                        </div>
                                        <div *ngIf="dataStep2.peso"
                                            class="d-flex container-body__step2__column-left__item" style="gap: 24px;">
                                            <div class="container-body__step2__column-left__item__title col-6">
                                                <p class="ls-label-small-semibold text-brand-10 text-uppercase">
                                                    {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.CFU" | translate}}</p>
                                            </div>
                                            <div class="container-body__step2__column-left__item__text col-6">
                                                <p class="ls-p-small text-neutral-30" [innerHTML]="dataStep2.peso"></p>
                                            </div>
                                        </div>
                                        <div *ngIf="dataStep2.ore"
                                            class="d-flex container-body__step2__column-left__item" style="gap: 24px;">
                                            <div class="container-body__step2__column-left__item__title col-6">
                                                <p class="ls-label-small-semibold text-brand-10 text-uppercase">
                                                    {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.HOURS" | translate}}</p>
                                            </div>
                                            <div class="container-body__step2__column-left__item__text col-6">
                                                <p class="ls-p-small text-neutral-30" [innerHTML]="dataStep2.ore"></p>
                                            </div>
                                        </div>
                                        <div *ngIf="dataStep2.des_semestre"
                                            class="d-flex container-body__step2__column-left__item" style="gap: 24px;">
                                            <div class="container-body__step2__column-left__item__title col-6">
                                                <p class="ls-label-small-semibold text-brand-10 text-uppercase">
                                                    {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.EDUCATIONAL_PERIOD" |
                                                    translate}}</p>
                                            </div>
                                            <div class="container-body__step2__column-left__item__text col-6">
                                                <p class="ls-p-small text-neutral-30"
                                                    [innerHTML]="dataStep2.des_semestre"></p>
                                            </div>
                                        </div>
                                        <div *ngIf="dataStep2.modules && dataStep2.modules.length && (dataStep2.modules.length > 1)"
                                            class="d-flex container-body__step2__column-left__item" style="gap: 24px;">
                                            <div class="container-body__step2__column-left__item__title col-6">
                                                <p class="ls-label-small-semibold text-brand-10 text-uppercase">
                                                    {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.MODULES" | translate}}</p>
                                            </div>
                                            <div class="container-body__step2__column-left__item__text col-6">
                                                <p class="ls-p-small text-neutral-30"
                                                    *ngFor="let module of dataStep2.modules; let idx = index"
                                                    [innerHTML]="idx !== (dataStep2.modules.length - 1) ? module.nome + ', ' : module.nome">
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="container-body__step2__column-right p-4 col-12 col-lg-8"
                                        *ngIf="dataStep2">
                                        <div class="container-body__step2__column-right__alert"></div>
                                        <div class="container-body__step2__column-right__text">
                                            <div *ngIf="dataStep2.contenuti">
                                                <p class="ls-pb-h2 text-brand-10">
                                                    {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.CONTENTS" |
                                                    translate}}</p>
                                                <p class="ls-p text-neutral-30"
                                                    [innerHTML]="formatHtml(dataStep2.contenuti)">
                                                    {{dataStep2.contenuti}}</p>
                                            </div>
                                            <div *ngIf="dataStep2.metodo">
                                                <p class="ls-pb-h2 text-brand-10">
                                                    {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.METHOD" |
                                                    translate}}</p>
                                                <p class="ls-p text-neutral-30"
                                                    [innerHTML]="formatHtml(dataStep2.metodo)"></p>
                                            </div>
                                            <div *ngIf="dataStep2['modalità_verifica_apprendimento']">
                                                <p class="ls-pb-h2 text-brand-10"
                                                    [innerHTML]="'CONTENT_TYPES.PAGE_CORSO_DI_STUDI.LEARNING_VERIFICATION_MODE' | translate">
                                                </p>
                                                <p class="ls-p text-neutral-30"
                                                    [innerHTML]="formatHtml(dataStep2['modalità_verifica_apprendimento'])">
                                                </p>
                                            </div>
                                            <div *ngIf="dataStep2.obiettivi_formativi">
                                                <p class="ls-pb-h2 text-brand-10">
                                                    {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.EDUCATIONAL_TARGETS" |
                                                    translate}}</p>
                                                <p class="ls-p text-neutral-30"
                                                    [innerHTML]="formatHtml(dataStep2.obiettivi_formativi)"></p>
                                            </div>
                                            <div *ngIf="dataStep2.prerequisiti">
                                                <p class="ls-pb-h2 text-brand-10">
                                                    {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.PREREQUISITES" |
                                                    translate}}</p>
                                                <p class="ls-p text-neutral-30"
                                                    [innerHTML]="formatHtml(dataStep2.prerequisiti)"></p>
                                            </div>
                                            <div *ngIf="dataStep2.testi_riferimento">
                                                <p class="ls-pb-h2 text-brand-10">
                                                    {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.REFERENCE_TEXTS"
                                                    | translate}}</p>
                                                <p class="ls-p text-neutral-30"
                                                    [innerHTML]="formatHtml(dataStep2.testi_riferimento)"></p>
                                            </div>
                                            <div *ngIf="dataStep2.obiettivi_sviluppo_sostenibile" class="mb-5">
                                                <p class="ls-pb-h2 text-brand-10">
                                                    {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.SUSTAINABLE_DEVELOPMENT_GOALS"
                                                    | translate}}
                                                </p>
                                                <p class="ls-p text-neutral-30"
                                                    [innerHTML]="formatHtml(dataStep2.obiettivi_sviluppo_sostenibile)">
                                                </p>
                                            </div>
                                            <div *ngIf="dataStep2.other_info" class="mb-5">
                                                <p class="ls-pb-h2 text-brand-10">
                                                    {{"CONTENT_TYPES.PAGE_CORSO_DI_STUDI.OTHER_INFO" |
                                                    translate}}</p>
                                                <p class="ls-p text-neutral-30"
                                                    [innerHTML]="formatHtml(dataStep2.other_info)">
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </li>
                    </ul>
                    <div [ngbNavOutlet]="nav" class=""></div>
                </div>
                <ng-container *ngIf="!isSpinnerStep2">
                    <div style="margin-top: -15vh;">
                        <app-spinner></app-spinner>
                    </div>
                </ng-container>
            </ng-container>
            <!-- SPINNER -->
            <!-- END STEP 2 -->
        </div>
    </ng-container>
    <!-- SPINNER -->
    <!-- <ng-template #isSpinnerModale>
        <app-spinner></app-spinner>
    </ng-template> -->
</ng-template>
<!-- MODALE TUTTI I DOCENTI -->
<ng-template #modalalDocenti let-modal>
    <ng-container *ngIf="block">
        <div class="container-header bg-brand-99">
            <div class="container-header__top-bar d-flex justify-content-between text-uppercase">
                <div class="col-1 text-center">
                    <div class="cursor-pointer" *ngIf="isStep2" (click)="resetBoolean()">
                        <i class="fa-solid fa-arrow-left text-brand-40" aria-hidden="true"></i>
                    </div>
                </div>
                <p class="col-10 ls-label-medium-semibold text-brand-40 text-center" id="modal-basic-title"
                    [innerHTML]="block.titolo"></p>
                <div class="col-1 close cursor-pointer text-center" aria-label="Close"
                    (click)="modal.dismiss(resetBoolean())">
                    <i class="fa-solid fa-plus text-brand-40" style="transform: rotate(45deg);" aria-hidden="true"></i>
                </div>
            </div>
        </div>
        <div class="container-body p-5 mb-3" *ngIf="allDocenti; else isSpinnerModaleAllDocenti">
            <ng-container *ngFor="let docente of allDocenti">
                <div (click)="onClickDocente(docente)">
                    <div class="card p-3 mb-3" [ngClass]="{'on-hover-border': docente.link_a_pagina_docente}">
                        <h3 class="d-flex ls-h3-item-title-small text-brand-10"
                            [innerHTML]="docente.nome + ' ' + docente.cognome">
                        </h3>
                        <div class="d-flex">
                            <p *ngIf="docente.dettaglio_ruoli_docente; else defaultRole"
                                class="m-0 me-1 ls-p-small text-brand-10" [innerHTML]="docente.dettaglio_ruoli_docente">
                            </p>
                            <ng-template #defaultRole>
                                <p class="m-0 me-1 ls-p-small text-brand-10"
                                    *ngFor="let role of docente.roles; let idx = index"
                                    [innerHTML]="idx !== (docente.roles.length - 1) ? role + ', ' : role"></p>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </ng-container>
    <!-- SPINNER -->
    <ng-template #isSpinnerModaleAllDocenti>
        <app-spinner></app-spinner>
    </ng-template>
</ng-template>
<!-- MODALE VIDEO PLAYER -->
<ng-template #modaleVideo let-modal>
    <ng-container *ngIf="block.iframe_video">
        <!-- <h2>MOdale video</h2> -->
        <app-sample-media-video [codice_iframe]="block.iframe_video"></app-sample-media-video>
    </ng-container>
</ng-template>